import React, { useState } from 'react';
import MaskedInput from 'components/MaskedInput';
import { GenericFormFields } from '../interfaces';
import { get } from 'lodash';

const GenericMaskedInputField: React.FC<GenericFormFields> = ({
  fields,
  item,
  values,
  setFieldValue,
  changeField,
  errors,
}) => {
  const initialValue = fields?.[item.stateKey] || values?.[item.stateKey] || '';

  const [value, setValue] = useState(initialValue);

  const field = get(fields, item.stateKey, null);

  React.useEffect(() => {
    field ? setValue(field) : setValue('');
  }, [fields, field]);

  return (
    <MaskedInput
      key={item.stateKey}
      mask={item.mask || ''}
      maskChar=""
      value={value}
      onChange={e => {
        if (item.validateOnChange) {
          setFieldValue && setFieldValue(item.stateKey, e.target.value);
          setValue(e.target.value);
        }
        setValue(e.target.value);
      }}
      onBlur={e => {
        if (setFieldValue) setFieldValue(item.stateKey, e.target.value);
        if (changeField)
          changeField({
            key: item.stateKey,
            value: Object(item).hasOwnProperty('id')
              ? { id: item.id, value: e.target.value }
              : e.target.value,
          });
      }}
      variant="outlined"
      label={item.label}
      error={
        !!get(errors, item.stateKey, null) || !!get(errors, item.error, null)
      }
      helperText={
        get(errors, item.stateKey, null) || get(errors, item.error, null)
      }
      disabled={item.disabled}
    />
  );
};

export default GenericMaskedInputField;
